import React from 'react'
import './ButtonLoader.css'
export default function ButtonLoader() {
    return (
        <div class="snippet" data-title="dot-typing">
        <div class="stage">
          <div class="dot-typing"></div>
        </div>
      </div>
    )
}
